import functionLang from './function'
import ruleLang from './rule'
import general from './general'
import login from './login'
import course from './course'
import assessment from './assessment'
export default {
   ...functionLang,
   ...ruleLang,
   ...general,
   ...login,
   ...course,
   ...assessment
}

